<template>
  <div>
    <!-- 发布协议对话框 -->
    <el-dialog title="发布协议" :visible.sync="dialogVisible" width="40%" modal-append-to-body append-to-body
      close-on-click-modal @closed="handleClose">
      <h4 style="text-align: center;">是否发布此条协议策略，发布后不可撤回，请跟产品同学对齐</h4>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitForm">发 布</el-button>
        <el-button size="small" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WebSaaSPublish',
  inject: ['loadList'],
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    /** 确认发布 */
    submitForm() {
      this.$emit('isSubmit', true)
      this.hide();
    },
    //^ ^--------------对话框自身相关-------------^ ^
    cancel() {
      this.$emit('isSubmit', false)
      this.hide()
    },
    show() {
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
    },
  },
};
</script>

<style lang="scss" scoped></style>